import { render, staticRenderFns } from "./QuizWordSearch.vue?vue&type=template&id=6350e338&"
import script from "./QuizWordSearch.vue?vue&type=script&lang=js&"
export * from "./QuizWordSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports